export default __webpack_public_path__ + "static/media/NeueMachina-Regular.38cf8c13.woff";